import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { NAMES_OF_ALLAH } from '../constants';
import './NamesPage.css';

export const NamesPage: React.FC = () => {
  const { colors } = useTheme();
  const { t } = useLanguage();
  const [selected, setSelected] = useState<typeof NAMES_OF_ALLAH[0] | null>(null);

  return (
    <div className="names-page" style={{ backgroundColor: colors.background, color: colors.text }}>
      <h2>{t.more.namesOfAllah}</h2>
      <p className="subtitle" style={{ color: colors.muted }}>The Beautiful Names of Allah</p>

      <div className="names-grid">
        {NAMES_OF_ALLAH.map((name) => (
          <div
            key={name.id}
            className="name-card"
            onClick={() => setSelected(name)}
            style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}
          >
            <div className="name-arabic" style={{ color: colors.tint }}>{name.arabic}</div>
            <div className="name-transliteration" style={{ color: colors.text }}>{name.transliteration}</div>
            <div className="name-meaning" style={{ color: colors.muted }}>{name.meaning}</div>
          </div>
        ))}
      </div>

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ backgroundColor: colors.cardBackground, borderColor: colors.border }}>
            <button className="modal-close" onClick={() => setSelected(null)} style={{ color: colors.text }}>×</button>
            <div className="modal-number" style={{ color: colors.muted }}>{t.more.nameNumber}{selected.id}</div>
            <div className="modal-arabic" style={{ color: colors.tint }}>{selected.arabic}</div>
            <div className="modal-transliteration" style={{ color: colors.text }}>{selected.transliteration}</div>
            <div className="modal-meaning" style={{ color: colors.muted }}>{selected.meaning}</div>
            <div className="modal-benefit" style={{ backgroundColor: colors.background, borderColor: colors.border }}>
              <div className="benefit-title" style={{ color: colors.muted }}>{t.more.spiritualBenefit}</div>
              <div className="benefit-text" style={{ color: colors.text }}>"{selected.benefit}"</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
